import React from "react";
import { Box, Skeleton } from "@mui/material";
import { cardSx } from "./StatsCardPayment";

const StatsCardPaymentSkeleton = () => (
  <Box sx={cardSx(false)}>
    <Box display="flex" alignItems="center" gap={1}>
      <Skeleton variant="rounded" width={32} height={32} />
      <Skeleton variant="text" width={110} height={20} />
    </Box>
    <Skeleton variant="text" width={90} height={34} />
    <Skeleton variant="text" width={140} height={20} />
    <Skeleton variant="text" width="70%" height={20} />
  </Box>
);

export default StatsCardPaymentSkeleton;
